import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../redux/slices/apiSlice";
import { fakeSlice } from "./slices/fakeSlice";
import pricingReducer from "../redux/slices/pricingSlice";
import commonComponentReducer from "../redux/slices/commonComponentSlice";
import authReducer from "../redux/slices/authSlice";
import pricingModalReducer from "./slices/pricingModalSlice";
import  dateRangeReducer  from "./slices/dateRangeSlice";
import filterReducer from "./slices/filterSlice";
import shapeCaratReducer from './slices/shapeCaratSlice';
import colorClarityReducer from './slices/colorClaritySlice';
import higherOrderReducer from './slices/higherOrderSlice';
import marketIntelligenceReducer from './slices/miShapeCaratSlice';
import summaryReducer from './slices/summarySlice';
import progressReducer from './slices/progressSlice';
import selectionReducer from './slices/selectionSlice';

export const store = configureStore({
  reducer: {
    pricing: pricingReducer,
    summary: summaryReducer,
    dateRange: dateRangeReducer,
    filters: filterReducer,
    shapeCarat: shapeCaratReducer,
    colorClarity: colorClarityReducer,
    higherOrder: higherOrderReducer,
    commonComponent: commonComponentReducer,
    progress: progressReducer,
    marketIntelligenceShapeCarat: marketIntelligenceReducer,
    auth: authReducer,
    pricingModal: pricingModalReducer,
    selection: selectionReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [fakeSlice.reducerPath]: fakeSlice.reducer,
  
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware,fakeSlice.middleware),
});
